/* eslint-disable react-hooks/exhaustive-deps */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { ParcelItems } from "../../components/charts/ParcelItems.chart";
import { useNavigate } from "react-router";

function ParcelStatsNewScreen() {
  /** Hooks */
  const navigate = useNavigate();

  /** Callbacks */
  const addParcel = () => navigate("/add-parcel");

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Parcel Stats
        </h1>
        <div className="flex flex-col sm:flex-row justify-end sm:items-center">
          <PrimaryButton
            onClick={addParcel}
            label="Add new Parcel"
            className="h-10 mb-1 sm:mb-0"
          />
        </div>
      </div>
      {/* Posht grafiket */}
      <ParcelItems />
    </div>
  );
}

export default withProtectedRoute(ParcelStatsNewScreen);
